import { MapInteractionCSS } from 'react-map-interaction';
import { Close } from '@material-ui/icons';
import utils from 'utils/utils';
import { makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';

export const useStyles = makeStyles(() => ({
    popupTitleIcon: {
        color: themes.palette.primary.main,
    },
    customCloseIcon: {
        position: 'absolute',
        top: '17px',
        right: '17px',
        zIndex: 999,
    },
    styleImage: {
        width: 'calc(100vw - 48px)',
        maxWidth: '1024px',
        objectFit: 'contain',
        marginTop: 20,
    },
    zoomImgContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
}));

export default function PreviewImage(props) {
    const classes = useStyles();
    const { heightContent, handleClose, selectedElement } = props;
    const getImageHeightForWidget = () => {
        return heightContent - 20;
    };
    const imageHeight = heightContent
        ? utils.isAppInWidgetMode()
            ? getImageHeightForWidget()
            : heightContent - 20
        : 0;
    return (
        <div>
            <Close className={`${classes.popupTitleIcon} ${classes.customCloseIcon}`} onClick={handleClose} />
            <MapInteractionCSS className={classes.zoomImgContainer} disablePan>
                <img
                    src={selectedElement?.value}
                    alt="item"
                    className={classes.styleImage}
                    style={{
                        height: imageHeight,
                    }}
                />
            </MapInteractionCSS>
        </div>
    );
}
